import $ from 'jquery'
import { Controller } from 'stimulus'

export default class extends Controller {
  static values = {
    to: String,
    key: String,
  }

  initialize() {
    const container = this.#moveToEl()
    if (!container) return

    // Keyed content is portalled once per container. This controller unwraps itself
    // (outerHTML = innerHTML below), so nothing survives to clean the content up later —
    // a second copy would simply accumulate. The keys live on the container rather than on
    // the content because the content has no wrapper left to carry them.
    const key = this.hasKeyValue ? this.keyValue : null
    const seen = key
      ? (container.dataset.portalledContentKeys || '')
          .split(' ')
          .filter(Boolean)
      : null
    if (key && seen.includes(key)) {
      this.element.remove()
      return
    }

    container.appendChild(this.element)
    this.element.outerHTML = this.element.innerHTML

    // Recorded only once the content is actually in. A key written ahead of the insert
    // would, if that insert ever failed, suppress every later copy for good.
    if (key) container.dataset.portalledContentKeys = [...seen, key].join(' ')

    // Run onDomChanged callbacks (e.g. .tinymce → prosemirror init) on the
    // newly-inserted content. We use $(container).changed() instead of
    // dispatching page:change because page:change also triggers onPageChange
    // callbacks (like form field auto-focus) which steal focus and close any
    // open dropdown.
    if (window.js_dom_ready) {
      $(container).changed()
    }
  }

  #moveToEl() {
    return document.querySelector(this.toValue)
  }
}
